import axios from "../../config/axiosConfig";
import {
  KARIGAR_SALARY_REPORT_REQUEST,
  KARIGAR_SALARY_REPORT_SUCCESS,
  KARIGAR_SALARY_REPORT_FAILURE,
  KARIGAR_SALARY_FILTER_REPORT_REQUEST,
  KARIGAR_SALARY_FILTER_REPORT_SUCCESS,
  KARIGAR_SALARY_FILTER_REPORT_FAILURE,
} from "../types/karigar-salary-report-types";

export const getKarigarSalaryReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: KARIGAR_SALARY_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        filterType: params?.filterType, 
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };

      // Log the request parameters
      // console.log('Request Param Datas >>>>>>>>>>>>>>>>>>>>>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/karigar-report/getKarigarReport?${queryString}`;

      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: KARIGAR_SALARY_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Karigar Salary Report:", error);
        dispatch({ type: KARIGAR_SALARY_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Karigar Salary Report:", error);
      dispatch({ type: KARIGAR_SALARY_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getKarigarSalaryFilterDetail = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: KARIGAR_SALARY_FILTER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        // commanMaster: auth?.company?.Common_Master,
      };

      // Merge default params with provided params
      const requestParams = { ...defaultParams };

      // Log the request parameters
      // console.log('Request Param Datas >>>>>>>>>>>>>>>>>>>>>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/short-excess/getShortExcessFilterDetail?${queryString}`;

      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: KARIGAR_SALARY_FILTER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Karigar Salary Report:", error);
        dispatch({ type: KARIGAR_SALARY_FILTER_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Short Excess Register Report:", error);
      dispatch({ type: KARIGAR_SALARY_FILTER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearKarigarSalaryReport = () => {
  return async (dispatch) => {
    dispatch({ type: KARIGAR_SALARY_REPORT_SUCCESS, payload: {} });
  }
}
